import React from 'react';
import PropTypes from 'prop-types';
import Modal from "semantic-ui-react/dist/es/modules/Modal/Modal.js";
import classnames from 'classnames';
import { Icon, ICON_NAMES } from "../Icon";
import { HorizontalGutters } from "../../layout/HorizontalGutters";
export var Component = function Component(_ref) {
  var children = _ref.children,
      className = _ref.className,
      closeIcon = _ref.closeIcon,
      hasCloseIcon = _ref.hasCloseIcon,
      hasPadding = _ref.hasPadding,
      hasRoundedCorners = _ref.hasRoundedCorners,
      header = _ref.header,
      isFullscreen = _ref.isFullscreen,
      isClosingOnDimmerClick = _ref.isClosingOnDimmerClick,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      size = _ref.size,
      trigger = _ref.trigger;
  return React.createElement(Modal, {
    className: classnames(className, {
      'has-padding': hasPadding,
      'has-rounded-corners': hasRoundedCorners
    }),
    closeIcon: hasCloseIcon && closeIcon,
    closeOnDimmerClick: isClosingOnDimmerClick,
    dimmer: "inverted",
    onClose: onClose,
    open: isOpen,
    size: isFullscreen ? 'fullscreen' : size,
    trigger: trigger
  }, !!header && React.createElement(Modal.Header, null, React.createElement(HorizontalGutters, null, header)), React.createElement(Modal.Content, null, children));
};
Component.displayName = 'Modal';
Component.defaultProps = {
  closeIcon: React.createElement(Icon, {
    name: ICON_NAMES.CLOSE
  }),
  className: null,
  header: null,
  hasCloseIcon: true,
  hasPadding: false,
  hasRoundedCorners: false,
  isFullscreen: false,
  isOpen: undefined,
  onClose: Function.prototype,
  trigger: null,
  size: 'tiny',
  isClosingOnDimmerClick: true
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  closeIcon: PropTypes.element,
  hasCloseIcon: PropTypes.bool,
  hasPadding: PropTypes.bool,
  hasRoundedCorners: PropTypes.bool,
  header: PropTypes.node,
  isClosingOnDimmerClick: PropTypes.bool,
  isFullscreen: PropTypes.bool,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  size: PropTypes.oneOf(['mini', 'tiny', 'small', 'large']),
  trigger: PropTypes.node
} : {};